import { FormMultipleProductsModel } from "src/app/models/form-multiple-productucs.model";
import { CustomerRequest, SalesOpportunityRequest } from "../models/sales-opportunity-request.model";

export class SalesOportunityRequestMap {

    static mapToCustomerRequest(formData: FormMultipleProductsModel, data:any): CustomerRequest {
      
      return new CustomerRequest(
        data.customerId,
        formData.documentId,
        data.isClient, 
        data.firstName,
        data.lastName,
        formData.phone,
        formData.phoneHome,
        formData.email,
        data.estadoCivil, 
        data.sexo 
      );
    }
  
    static mapToSalesOpportunityRequest(formData: FormMultipleProductsModel, data:any): SalesOpportunityRequest {
      return new SalesOpportunityRequest(
        formData.selectionOpt,
        this.mapToCustomerRequest(formData, data)
      );
    }
  }